import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

// import Parallax from 'components/Parallax/Parallax.jsx'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

const bannerStyle = theme => ({
  banner: {
    ...theme.banner,
    // background:
    //   'linear-gradient(180deg, rgba(3, 43, 67, 1) 0%, rgba(3, 43, 67, 1) 85px, rgba(255, 255, 255, 1) 100%)',
  },
  baseline: {
    color: theme.palette.primary.main,
    fontWeight: 400,
    '& span': {
      fontWeight: 400,
      color: theme.palette.secondary.main,
    },
  },
})

const Banner = ({ classes, data }) => {
  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.banner}
      id="home"
    >
      <Grid item xs={10} md={9}>
        <Typography
          variant="h2"
          gutterBottom
          // color="primary"
          classes={{ h2: classes.baseline }}
        >
          I build efficient and scalable digital products using{' '}
          <span>React</span> and <span>Ruby on Rails</span>
        </Typography>
      </Grid>
    </Grid>
  )
}

const StyledBanner = withStyles(bannerStyle)(Banner)

export default props => (
  <StaticQuery
    query={graphql`
      query {
        backgroundImage: file(relativePath: { eq: "bg2.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <StyledBanner data={data} {...props} />}
  />
)
